<!-- <svelte:head>
	<link rel="stylesheet" href="tutorial/dark-theme.css">
</svelte:head> -->

<script>
  import { SHA256 } from 'crypto-es/lib/sha256';
  import { MD5 } from 'crypto-es/lib/md5.js';
  import CryptoES from 'crypto-es';
  import Header from './Header.svelte';
  import GlobalFooter from './GlobalFooter.svelte';
  import StatsTable from './StatsTable.svelte';
  import HelpDialog from './HelpDialog.svelte';
  import { fade } from 'svelte/transition';
  import { onMount } from 'svelte';
  import statsAviva from './data/stats.json';
  import users from './data/u.json';
  import SvelteSeo from "svelte-seo";
  import "smelte/src/tailwind.css" ;
  import TextField from "smelte/src/components/TextField";
  import Card from "smelte/src/components/Card";
  import Button from "smelte/src/components/Button";
  import Select from "smelte/src/components/Select";
  import Tooltip from "smelte/src/components/Tooltip";
  import { showHelpDialog } from './store.js';

  import dark from "smelte/src/dark"

  const darkMode = dark();

  let anonymizedData = '';
  let selectedCategory = '';

  let username = '';
  let password = '';
  let showFakeData = false;

  const toutesLesCategories = "-- Toutes les catégories --";
  const libelleSelectCategories = "Catégories"
  let listOfCategories = ["initial-value"];
  let lastElementIndex = 0;

function filterByCategory(dataList, categorie){
  let clonedData = JSON.parse(JSON.stringify(dataList));
  if(!categorie || categorie == toutesLesCategories){
    return clonedData;
  }
  return clonedData.filter(elem => elem.categorie.toUpperCase() === categorie.toUpperCase());
}


function filterByMyProject(dataList, myProject){
  if(!myProject){
    return [];
  }
  let clonedData = JSON.parse(JSON.stringify(dataList));

  let projetFound = clonedData.filter(elem => elem.projet.toLowerCase() === myProject.toLowerCase());
  
  if(projetFound && projetFound.length > 0){
    
    let classement = projetFound[0].ordre;
    let smallArray = [];
    if(classement >= 4){
      smallArray.push(clonedData[classement-4]);
    }
    if(classement >= 3){
      smallArray.push(clonedData[classement-3]);
    }
    if(classement >= 2){
      smallArray.push(clonedData[classement-2]);
    }
    if(classement >= 1){
      smallArray.push(clonedData[classement-1]);
    }
    if(classement < clonedData.length){
      smallArray.push(clonedData[classement]);
    }
    if(classement+1 < clonedData.length){
      smallArray.push(clonedData[classement+1]);
    }
    if(classement+2 < clonedData.length){
      smallArray.push(clonedData[classement+2]);
    }

    return smallArray;
  }

  return [];
}

function onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
}

function getListOfCategories(dataList){
  let allCategories = dataList.map(elem => elem.categorie);
  let uniqueCategories = allCategories.filter(onlyUnique);
  uniqueCategories.sort()
  uniqueCategories.unshift(toutesLesCategories);
  return uniqueCategories;
}

function byVotes(a,b){ 
  return a.nbVotes > b.nbVotes ? -1 : 1; 
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

function anonymizeData(dataList){
  let clonedData = JSON.parse(JSON.stringify(dataList));
  let randomLetters = Math.random().toString(36).substr(2, 5);
  anonymizedData = clonedData.map(row => {
    row.projet = MD5(row.projet + randomLetters).toString().substring(0,10);
    row.votes = row.votes + getRandomInt(1, 20);
    return row;
    });
  return anonymizedData;
}

function formatDate(date){
  const year = date.substring(0,4);
  const month = date.substring(5,7);
  const day = date.substring(8,10);

  const hour = date.substring(11,13);
  const minute = date.substring(14,16);
  const second = date.substring(17,19);
  return day + '/' + month + '/' + year + ' à ' + hour + 'h' + minute;
}


function buildUrl(id, txt){
  return '<a href="https://lafabrique-france.aviva.com/voting/projet/vue/' + id + '" target="_blank" rel="noreferrer">' + txt + '</a>';
}

function toProperCase(str){
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

function isKnownUser(username){
  
  if(!username || !username.trim()){
    return false;
  }
  const hashedName = SHA256(username).toString();

  let userTrouve = users.list.filter(curUser => curUser.u == hashedName );
  let utilisateurExistant = userTrouve.length > 0 ? true : false;

  if(utilisateurExistant){
    hideFakeData();
  }

  return utilisateurExistant;
}

function getUserHashedProject(username){
  const hashedName = SHA256(username).toString();

  let userTrouve = users.list.filter(curUser => curUser.u == hashedName );
  if(userTrouve.length >0){
    return userTrouve[0].p;
  }else{
    return "";
  }
}

function isPwdCorrect(pwd){
  let pwdApp = users.main.entry;
  return SHA256(pwd).toString() === pwdApp;
}

function displayFakeData(){
  showFakeData = true;
}

function hideFakeData(){
  showFakeData = false;
}

function decrypt(encryptedData){
  if(!password){
    return encryptedData;
  }
  var outro = "roplacmidt";

  var base64Key = CryptoES.enc.Base64.stringify(CryptoES.enc.Utf8.parse(password + outro));

  // this is the actual key as a sequence of bytes
  var key = CryptoES.enc.Base64.parse(base64Key);

  // this is the decrypted data as a sequence of bytes
  var decryptedData = CryptoES.AES.decrypt( encryptedData, key, {
      mode: CryptoES.mode.ECB,
      padding: CryptoES.pad.Pkcs7,
      iv: CryptoES.enc.Hex.parse('00000000000000000000000000000000')
  } );


  var decryptedText = "";
  try {
    // this is the decrypted data as a string
    decryptedText = decryptedData.toString( CryptoES.enc.Utf8 );
  } catch (error) {
    decryptedText = "Erreur sur le projet"
    // expected output: ReferenceError: nonExistentFunction is not defined
    // Note - error messages will vary depending on browser
  }
  
  return decryptedText;
}

function decryptData(data){
  return data.map(line => {
      line.projet = decrypt(line.projet);
      return line;
    }
  )
}

function main(){
  listOfCategories = getListOfCategories(statsAviva.snapshots[lastElementIndex].avivaLines);
  lastElementIndex = statsAviva.snapshots.length - 1;
}


onMount(() => {
    main();
	});

</script>


<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500|Material+Icons&display=swap"
    rel="stylesheet" />

<SvelteSeo
  title="Aviva stats - Classement la Fabrique Aviva 2021"
  description="Classement des votes pour le concours la Fabrique Aviva 5ème édition 2020-2021"
  canonical="https://aviva-stats.netlify.app"
  openGraph={{
    title: 'Aviva stats - Classement la Fabrique Aviva 2021',
    description: 'Classement des votes pour le concours la Fabrique Aviva 5ème édition 2020-2021',
    url: 'https://aviva-stats.netlify.app',
    type: 'website'
  }}
/>

<div class="px-10 py-5">

<div class="px-5 flex-1 italic text-sm">Le site est maintenant fermé suite à la fin des votes. Merci pour votre compréhension.</div>

<!--   <Header/>
  <div class="flex flex-row my-5">
    <div class="px-5 flex-1 italic text-sm">Dernière mise à jour le {formatDate(statsAviva.lastUpdate)}</div>
    <Button on:click={showHelpDialog.display}>ℹ Aide</Button>
    <Tooltip>
      <div slot="activator">
        <Button class="ml-1" bind:value={$darkMode}>{$darkMode ? "☀︎" : "☾"}</Button>
      </div>
      {$darkMode ? "Mode clair" : "Mode sombre"}
    </Tooltip>  
  </div>
  
  <Card.Card class="mb-10 w-full">
    <div slot="title">
      <Card.Title
        title="Connexion"
      />
    </div>
    <div slot="text" class="px-5 py-0 text-gray-700 body-2 flex flex-row flex-wrap justify-between">
      <div class="p-4 flex flex-col">
        <div>Connectez-vous pour avoir accès aux données.</div>
          <TextField bind:value={username} label="Email" />
          {#if isKnownUser(username)}
          <div transition:fade>
            <TextField type="password" bind:value={password} label="Mot de passe" />
          </div>
          {/if}
      </div>
      <div class="p-4">
        
      </div>
      <div class="p-4 flex flex-col">
      {#if !isKnownUser(username) || !isPwdCorrect(password)}
        <div>Demander accès au classement</div>
        <a class="a" href="https://www.buymeacoffee.com/kisco" target="_blank" >Sur mon profil "BuyMeACoffee"</a>
        {/if}
      </div>
      <div class="p-4">
        
      </div>
      <div class="p-4 flex flex-col">
        {#if !isKnownUser(username) || !isPwdCorrect(password)}
          <div>Affichez des données anonymisées pour avoir un aperçu.</div>
          <Button on:click={displayFakeData}>Afficher</Button>
        {/if}
      </div>
    </div>
  </Card.Card>

  {#if isKnownUser(username) && isPwdCorrect(password)}

    <div class="mb-10" transition:fade>
        <div class="flex flex-row">
          <div class="flex flex-col mr-6">
            <p>Classement complet</p>
            <StatsTable data={decryptData(filterByCategory(statsAviva.snapshots[lastElementIndex].avivaLines, selectedCategory))} />
          </div>
          <div class="flex flex-col">
            <p>Ma position</p>
            <StatsTable data={decryptData(filterByMyProject(statsAviva.snapshots[lastElementIndex].avivaLines, getUserHashedProject(username)))} />
          </div>
        </div>
    </div>

    
  {:else}

    {#if showFakeData}
    <div class="mb-10" transition:fade>
        <StatsTable data={anonymizeData(statsAviva.snapshots[lastElementIndex].avivaLines)} />
    </div>
    {/if}
  {/if}

  <HelpDialog />
  
  <GlobalFooter/> -->
</div>